import { DateT } from '@mulesoft/anypoint-components/lib/DatePicker'
import DateType from '@mulesoft/monitoring-center-components/lib/utils/date/DateType'

export const MAX_SELECTABLE_DAYS = 90

const MILLIS_PER_DAY = 24 * 60 * 60 * 1000

export function exceedsMaxWindow(time: DateT, maxDays: number = MAX_SELECTABLE_DAYS): boolean {
  const { value } = time

  if (!DateType.isCustomDate(value)) {
    return false
  }

  const [from, to] = value.range
  const fromTime = Date.parse(from)
  const toTime = Date.parse(to)

  if (isNaN(fromTime) || isNaN(toTime)) {
    return false
  }

  const spanInDays = Math.abs(toTime - fromTime) / MILLIS_PER_DAY
  return spanInDays > maxDays
}
